import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageAdd } from './MessageAdd';
import { CircularProgress, Stack } from '@mui/material';

import useFetch from '../hooks/useFetch';
import { AuthContext } from '../auth/authContext';
import { types } from '../types/types';

/* --------Props--------
reset: el reset del formulario padre
setIsCreate: estado del padre que cumple función condicional para renderizar este componente
headers: ya tiene incluido el Bearer del auth, solo si hace falta enviar algo más
messages: creados en /helpers, tomar modelo de otro ya creado
method: GET, PUT, DELETE, POST, etc
body: solo si necesitamos enviar algo, no obligatorio

*/
export const Message = ({ reset, setIsCreate, headers, messages, method, body }) => {

    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const { status, data, error } = useFetch(messages.url, method, headers, body);
    const { user, dispatch } = useContext(AuthContext)

    useEffect(() => {
        setOpen(true)
    }, [open])

    const handleClose = () => {
        if (messages.type === 'editEstimate') {
            navigate('/estimate')
        } else if(messages.type === 'addCertification') {
            navigate('/certification')
        } else if(messages.type === 'editWork') {
            navigate('/work')
        }else {
            reset();
            setIsCreate(false)
            setOpen(!open)
        }
    }

    const goClient = () => {
        if (messages.type === 'forgotPassword') {
            reset();
            setIsCreate(false)
            setOpen(!open)

        } else if (messages.type === 'createUser') {
            navigate('/configuration')
        } else if (messages.type === 'saveNewPassword') {
            dispatch({
                type: types.login,
                payload: { email: user.email, logged: true, updatePass: '', rol: user.rol }
            })
            reset(false);
            setIsCreate(false)
        } else if (messages.type === 'saveNewTel') {
            reset(false)
        } else if (messages.type === 'saveNewEmail') {
            sessionStorage.removeItem('authToken');
            localStorage.removeItem('authToken');
            dispatch({
                type: types.logout,
                payload: {
                    logged: false,
                    email: ''
                }
            })
        } else if (messages.type === 'addCertification') {
            navigate('/printCertification?id='+ (data?.id|| body.id))
        } else if (messages.type === 'editEstimate' || messages.type === 'addEstimate') {
            if (data?.id|| body.id || data?.estimates.id){
                navigate('/printEstimate?id=' + (data?.id|| body.id || data?.estimates.id))
            } else {
                navigate('/estimate')
            }
            
        } else if (messages.type === 'createProduct') {
            navigate('/product')
        } else if (messages.type === 'editWork') {
            navigate('/works')
        } else {
            navigate('/client')
        }
    };

    return (
        <div>
            {status === undefined && <Stack mb='2rem' mt='1rem' width='100%' alignItems='center'><CircularProgress /></Stack>}
            {status && <MessageAdd open={open} handleClose={handleClose} goClient={goClient} message={messages.messageTextsOK} />}
            {status === false && <MessageAdd open={open} handleClose={handleClose} goClient={goClient} message={messages.messageTextsKO} repeat={error.original?.code === 'ER_DUP_ENTRY'}/>}

        </div>
    )
}